import { useCallback, useEffect, useMemo, useState } from 'react';
import Services from '../../../../../bridge/utils/Services';
import LogsScreen from '../LogsScreen';
import { LogRecordType } from '../../../../../bridge/utils/LogRecord';
import LogsFilter from '../Filter';
import useRequest from '../../../../../hooks/useRequest';
import ServicePaths from '../../../../../bridge/utils/ServicePaths';
import { Bot } from '../../../../Detail/types';
import useLogsWebsocket from '../../../../../hooks/useLogsWebsocket';

const BotLogs = () => {
  const { data: botsData } = useRequest(ServicePaths.DATA.GetAllActiveBots);

  const botIds = useMemo(() => {
    if (!botsData?.bots?.length) {
      return [];
    }

    return (botsData?.bots as Bot[]).map((b) => b.botId);
  }, [botsData?.bots]);

  const [activeBot, setActiveBots] = useState<Bot | undefined>();

  const handleBoCchange = useCallback(
    (botId: string) => {
      setActiveBots(botsData?.bots.find((b: Bot) => b.botId === botId));
    },
    [botsData?.bots],
  );

  useEffect(() => {
    if (!botsData?.bots?.length) {
      return;
    }

    setActiveBots(botsData?.bots[0]);
  }, [botsData?.bots]);

  const [searchQuery, setSearchQuery] = useState('');
  const [messageTypes, setMessageTypes] = useState([
    LogRecordType.Info,
    LogRecordType.Variable,
    LogRecordType.Error,
  ]);

  const [startTimestamp, setStartTimestamp] = useState<string | undefined>();
  const [endTimestamp, setEndTimestamp] = useState<string | undefined>();

  const amountOfLogs = [200, 500, 1000, 2000, 5000];
  const [maxLogs, setMaxLogs] = useState(amountOfLogs[0]);

  const { logRecords, isLoading } = useLogsWebsocket(
    undefined,
    activeBot?.activePort,
    undefined,
    searchQuery,
    startTimestamp,
    endTimestamp,
  );

  return (
    <div
      style={{
        margin: 20,
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <LogsFilter
        bots={botIds}
        activeBot={activeBot?.botId}
        handleBotChange={handleBoCchange}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        maxLogs={maxLogs}
        setMaxLogs={setMaxLogs}
        amountOfLogs={amountOfLogs}
        startTimestamp={startTimestamp}
        setStartTimestamp={setStartTimestamp}
        endTimestamp={endTimestamp}
        setEndTimestamp={setEndTimestamp}
        messageTypes={messageTypes}
        setMessageTypes={setMessageTypes}
      />

      <LogsScreen
        id={activeBot?.botId || 'unactive'}
        logRecords={logRecords}
        isLoading={isLoading}
        messageTypes={messageTypes}
        maxLogs={maxLogs}
      />
    </div>
  );
};

export default BotLogs;
